let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5rr8k")).then(() => parcelRequire('7XHWD'));